import { ReactNode } from "react";
import PageHeader from "@/components/PageHeader";
import DashboardSidebar from "@/components/dashboard/DashboardSidebar";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { useAuth } from "@/contexts/AuthContext";

interface Props {
  children: ReactNode;
  /** Sayfa kendi PageHeader'ını render ediyorsa false verilir. */
  header?: boolean;
}

/**
 * Header + soldaki role duyarlı gezinme menüsü ile ortak uygulama kabuğu.
 * Oturum yoksa sidebar gösterilmez (misafirlere kilitli menü sunulmaz).
 */
const AppShell = ({ children, header = true }: Props) => {
  const { user } = useAuth();

  if (!user) {
    return (
      <div className="min-h-screen bg-background">
        {header && <PageHeader />}
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      {header && <PageHeader />}
      <SidebarProvider>
        <div className="flex w-full">
          <DashboardSidebar />
          <main className="flex-1 min-w-0">
            <div className="sticky top-16 z-30 flex items-center gap-2 bg-background/80 backdrop-blur px-4 md:px-6 py-2 border-b border-border/40">
              <SidebarTrigger className="text-muted-foreground hover:text-foreground" />
            </div>
            {children}
          </main>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default AppShell;
